import { ProfessionEnum } from '../../../resources/base/models';

const occupationGroupA: CreditIntegration.Schemas.OccupationEnumValue[] = [
  ProfessionEnum['80_CHOMEURS'],
  ProfessionEnum['97_DIRIGEANT_DE_SOCIETE'],
  ProfessionEnum['70_RETRAITES'],
  ProfessionEnum['94_ENTREPRISE_INDIVIDUELLE'],
  ProfessionEnum['99_PROFESSION_LIBERALE'],
  ProfessionEnum['93_AGRICULTEUR'],
  ProfessionEnum['96_INVALIDE'],
  ProfessionEnum['84_ELEVES_ETUDIANTS'],
  ProfessionEnum['86_PERS_SANS_ACTIVITE_PROF_GREATER_60'],
  ProfessionEnum['85_PERS_SANS_ACTIVITE_PROF_LESS_60'],
  ProfessionEnum['98_AUTO_ENTREPRENEUR'],
];

const occupationGroupB: CreditIntegration.Schemas.OccupationEnumValue[] = [
  ProfessionEnum['96_INVALIDE'],
  ProfessionEnum['84_ELEVES_ETUDIANTS'],
  ProfessionEnum['86_PERS_SANS_ACTIVITE_PROF_GREATER_60'],
  ProfessionEnum['85_PERS_SANS_ACTIVITE_PROF_LESS_60'],
];

export const getOccupationGroupFlags = (mainPosFrOccupation: CreditIntegration.Schemas.OccupationEnumValue) => ({
  isOccupationGroupA: occupationGroupA.includes(mainPosFrOccupation),
  isOccupationGroupB: occupationGroupB.includes(mainPosFrOccupation),
});
